import { OrderUpdateActions } from "store/modules/Orders/types.store";
// import CancelOrder from "./components/CancelOrder";

interface ModalProps {
  description: string;
  confirmLabel: string;
  denyLabel: string;
  onConfirm: (state: unknown) => void;
  title: string;
  body?: RenderableBody;
}

interface RenderableBodyProps {
  onChangeBodyState: any;
  state: any;
}

type RenderableBody = (props: RenderableBodyProps) => JSX.Element;

export default (type?: OrderUpdateActions): ModalProps => {
  switch (type) {
    case "accept":
      return {
        description: "Você deseja aceitar o pedido?",
        confirmLabel: "Aceitar",
        denyLabel: "Sair",
        title: "Aceitar pedido",
        onConfirm: () => {},
      };
    case "start":
      return {
        description: "Você deseja iniciar o pedido?",
        confirmLabel: "Iniciar",
        denyLabel: "Sair",
        title: "Iniciar pedido",
        onConfirm: () => {},
      };
    case "finalize":
      return {
        description: "Você deseja finalizar o pedido?",
        confirmLabel: "Finalizar pedido",
        denyLabel: "Sair",
        title: "Finalizar pedido",
        onConfirm: () => {},
      };
    default:
      return {
        description: "",
        confirmLabel: "",
        denyLabel: "",
        title: "",
        onConfirm: () => {},
      };
  }
};
